module.exports = __webpack_public_path__ + "./images/video_poster.899e329961d29dc7defe5755ae61ae2e.png";